import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

type RequireAuthProps = {
  children: React.ReactNode;
};

export default function RequireAuth({ children }: RequireAuthProps) {
  const location = useLocation();
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="bg-gradient-to-b from-[#E6F7F4] to-[#C5E8E3] min-h-[calc(100vh-8rem)] flex items-center justify-center">
        <p className="text-gray-600 text-sm">Checking your session…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/register" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
}
